module.exports = __webpack_public_path__ + "static/media/daily_bao.0ede4d17.png";